import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchCategory, fetchDepartment, fetchDesignation, getWagesalaryRegister, clearapproveError1 } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";
import useButtonAccess from "components/Common/useButtonAccess";
import classnames from "classnames";
import Loader from "common/pageLoader";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";

const PayrollReportWagesRegister = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const [data, setdata] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    dispatch(fetchCategory(authUserDetails[0].unit_id));
    dispatch(fetchDepartment(authUserDetails[0].unit_id));
    dispatch(fetchDesignation(authUserDetails[0].unit_id));
  }, [dispatch]);

  const {
    employees,
    categoryList,
    departmentList,
    designationList,
    wageregister,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    wageregister: state.PayrollReportsReducer?.wageregister ?? [],
    loading: state.PayrollReportsReducer?.loading,
    error: state.PayrollReportsReducer?.error,
    success: state.PayrollReportsReducer?.success,
  }));

  let categoryOptions = [], deptOptions = [], desigOption = [], employeeslist = [];
  categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));
  desigOption = (designationList || []).map(item => ({ label: item.designation, value: item.desig_id }));
  employeeslist = (employees || []).map(item => ({ label: item.emp_no, value: item.emp_id }));

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      month: "",
      employee: "",
    },
    validationSchema: Yup.object({
      month: Yup.string().required("Month is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("emp_cat", values.category?.value || 0);
      formData.append("emp_dep", values?.department?.value || 0);
      formData.append("designation", values?.designation?.value || 0);
      formData.append("emp_code", values?.employee?.value || 0);
      formData.append("month", values?.month || null);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(getWagesalaryRegister(formData));
    },
  });

  useEffect(() => {
    if (wageregister?.data?.length > 0) {
      const Data = wageregister?.data?.map((emp, index) => ({
        sno: emp.s_no,
        code: emp.code,
        name: emp.name,
        gender: emp.gender,
        date_of_join: emp.date_of_join,
        category: emp.category,
        department: emp.department,
        designation: emp.designation,
        ot_hours: emp.ot_hours,
        total_days: emp.total_days,
        present_days: emp.present_days,
        week_off: emp.week_off,
        holiday: emp.holiday,
        paid_leave_days: emp.paid_leave_days,
        absent_days: emp.absent_days,
        net_paid_days: emp.net_paid_days,
        gross_earnings: emp.gross_earnings,
        basic: emp.basic,
        da: emp.da,
        hra: emp.hra,
        conv: emp.conv,
        washing: emp.washing,
        canteen: emp.canteen,
        late: emp.late,
        sal_advance: emp.sal_advance,
        tea: emp.tea,
        gross_deductions: emp.gross_deductions,
        net_amount_payable: emp.net_amount_payable
      })) || [];

      setdata(Data);
    } else {
      dispatch({ type: "RESET_SAVE_STATUS" });
      setdata([]);
    }
  }, [wageregister]);

  const baseColumns = [
    { Header: "S.NO", Cell: ({ row }) => data?.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "CODE", accessor: "code" },
    { Header: "NAME", accessor: "name" },
    { Header: "GENDER", accessor: "gender" },
    { Header: "DOJ", accessor: "doj" },
    { Header: "CATEGORY", accessor: "category" },
    { Header: "DEPARTMENT", accessor: "department" },
    { Header: "DESIGNATION", accessor: "designation" },
    { Header: "WAGE_TYPE", accessor: "wages_type" },
    { Header: "FIXED_GROSS", accessor: "fixed_gross" },
    { Header: "TOTAL_DAYS", accessor: "total_days" },
    { Header: "PAID_DAYS", accessor: "paid_days" },
    { Header: "WO_DAYS", accessor: "wo_days" },
    { Header: "HOLIDAY", accessor: "holiday" },
    { Header: "LOP_DAYS", accessor: "lop_days" }
  ];

  // Dynamic Allowances
  const allowanceColumns = (wageregister?.allowances || []).map(a => ({
    Header: a.replace(/_/g, "").toUpperCase(),
    accessor: a,
    sum: true
  }));

  // Dynamic Deductions
  const deductionList = wageregister?.deductions || [];

  const deductionColumns = deductionList.map(d => ({
    Header: d.replace(/_/g, " ").toUpperCase(),
    accessor: d,
    sum: true,
    width: 110
  }));

  const columns = [
    ...baseColumns,
    ...allowanceColumns,
    { Header: "GROSS", accessor: "gross_earnings", sum: true },
    ...deductionColumns,
    { Header: "TOTAL_DEDUCTION", accessor: "deductions", sum: true },
    { Header: "NET_AMOUNT", accessor: "net_amount", sum: true }
  ];

  const resetFormData = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    formik.resetForm({
      values: {
        category: "",
        department: "",
        designation: "",
        employee: "",
        month: "",
      },
    });
    setdata([]);
  };

  useEffect(() => {
    return () => {
      dispatch(clearapproveError1());
    };
  }, []);

  return (
    <React.Fragment>
      <Loader loading={loading} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Payroll / Reports / Salary Reports" breadcrumbItem="Wage Register" />
          <Card>
            <CardBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3}>
                    <Label>Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      isMulti={false}
                      options={categoryOptions || []}
                      value={formik.values.category || null}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("category", selectedOption); if (selectedOption) { }
                      }}
                      onBlur={() => formik.setFieldTouched("category", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Department</Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      isMulti={false}
                      options={deptOptions || []}
                      value={formik.values.department || null}
                      onChange={(selectedOption) => { formik.setFieldValue("department", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("department", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />

                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger small">{formik.errors.department}</div>
                    )}
                  </Col>
                  <Col md={3}>
                    <Label>Designation</Label>
                    <CustomSelect
                      id="designation"
                      name="designation"
                      isMulti={false}
                      options={desigOption || []}
                      value={formik.values.designation || null}
                      onChange={(selectedOption) => { formik.setFieldValue("designation", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("designation", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Employee Code</Label>
                    <CustomSelect
                      id="employee"
                      name="employee"
                      isMulti={false}
                      options={employees}
                      value={formik.values.employee || null}
                      onChange={(selectedOption) => { formik.setFieldValue("employee", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("employee", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Month <span className="text-danger">*</span></Label>
                    <CustomMonthPicker
                      name="month"
                      value={formik.values.month}
                      onChange={(date) => { formik.setFieldValue("month", date); }}
                      onBlur={formik.handleBlur}
                      className={`form-control ${formik.touched.month && formik.errors.month ? "is-invalid" : ""}`}
                    />
                    {formik.touched.month && formik.errors.month && (
                      <div className="text-danger">{formik.errors.month}</div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex align-items-center justify-content-end">
                    <Button type="submit" className="btn button-search me-2 mt-2" ><i className="fas fa-search me-1" /> Search</Button>
                    <Button type="reset" className="btn button-cancel me-2 mt-2"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            resetFormData();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(wageregister?.data || [], authDetails?.unit_fullname, authDetails?.unit_address, "WAGE_REGISTER")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(wageregister?.data || [], authDetails?.unit_fullname, authDetails?.unit_address, "WAGE_REGISTER", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <TableContainerColumnTotal columns={columns} data={wageregister?.data || []} isGlobalFilter={true} customPageSize={10} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollReportWagesRegister;
